export const langSwitcher = () => {
  const ROOT = '[data-lang-switcher]';
  const TOGGLE = '[data-lang-toggle]';
  const MENU = '[data-lang-menu]';

  const close = (root) => {
    const btn = root.querySelector(TOGGLE);
    const menu = root.querySelector(MENU);
    if (!btn || !menu) return;

    btn.setAttribute('aria-expanded', 'false');
    menu.hidden = true;
  };

  const closeAll = (except = null) => {
    document.querySelectorAll(ROOT).forEach((root) => {
      if (except && root === except) return;
      close(root);
    });
  };

  const toggle = (root) => {
    root.classList.toggle('lang-switcher--active');
    const btn = root.querySelector(TOGGLE);
    const menu = root.querySelector(MENU);
    if (!btn || !menu) return;

    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    closeAll(root);

    btn.setAttribute('aria-expanded', String(!isOpen));
    menu.hidden = isOpen;
  };

  // ustaw stan początkowy (na wszelki wypadek)
  document.querySelectorAll(ROOT).forEach((root) => close(root));

  // click: otwieranie / zamykanie oraz klik poza
  document.addEventListener('click', (e) => {
    const root = e.target.closest(ROOT);
    const btn = e.target.closest(TOGGLE);

    if (btn && root) {
      e.preventDefault();
      toggle(root);
      return;
    }

    if (!root) closeAll();
  });

  // ESC zamyka
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
};